var _path, _rect, _g, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1754 1.29989C12.093 0.779782 13.2164 0.779783 14.134 1.29989L17.8915 3.42967L21.6148 5.61891C22.524 6.15355 23.0857 7.1264 23.0941 8.18114L23.1284 12.5002L23.0941 16.8192C23.0857 17.8739 22.524 18.8468 21.6148 19.3814L17.8915 21.5706L14.134 23.7004C13.2164 24.2205 12.093 24.2205 11.1754 23.7004L7.41785 21.5706L3.69463 19.3814C2.78539 18.8468 2.22372 17.8739 2.21533 16.8192L2.181 12.5002L2.21533 8.18114C2.22372 7.12639 2.78539 6.15355 3.69464 5.61891L7.41785 3.42967L11.1754 1.29989Z",
    fill: "var(--iconSecondary)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3146_10416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 14,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.81152,
    y: 6.44141,
    width: 12.5217,
    height: 11.52,
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3146_10416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 18.7761C15.3548 16.4416 11.0491 13.5714 1.92271 12.5491",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.675 20.9792C13.5296 18.6447 9.22386 15.7745 0.0975156 14.7522",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85,
    strokeDasharray: "2.67 1.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6095 23.6179C14.4642 21.2834 10.1584 18.4131 1.03209 17.3909",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4839 21.6601C16.9848 20.1136 12.231 18.0692 3.07026 18.7139",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6956 15.2516C13.4167 14.5422 16.0871 13.1721 20.9996 13.3675",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.26408,
    cy: 9.56071,
    r: 2.0278,
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7886 10.4214C15.2532 10.4214 15.7313 10.9398 15.7313 12.3565C14.2668 12.3565 13.7886 11.8744 13.7886 10.4214Z",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6741 10.4214C16.2095 10.4214 15.7313 10.9398 15.7313 12.3565C17.1958 12.3565 17.6741 11.8744 17.6741 10.4214Z",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7358 13.9817V12.0493",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.1bc61c9680864ef9a9c27f2c907d3e31.svg";
export { ForwardRef as ReactComponent };